export const removeSpaces = (text) => {
    return typeof text === "string" ? text.replace(/ /g, "") : text;
};
